import { FormApiMethodsRequestData } from '../../types/types';
import { FormType, JSONObject, MultiSelectMode } from '../../../types/types';

type GetFormApiMethodsRequestDataArgs = {
  tokenRequestData: FormApiMethodsRequestData | undefined;
  formType: FormType;
  mode: MultiSelectMode;
  sessionId: string;
  form: JSONObject;
  // id of the row currently being edited (sequential multiselect paginates through rows)
  currentRowId: string | undefined;
};

// Builds the resolve data passed to apiMethod JSONata evaluation for form inputs, handlers and controls.
export const getFormApiMethodsRequestData = ({
  tokenRequestData,
  formType,
  mode,
  sessionId,
  form,
  currentRowId,
}: GetFormApiMethodsRequestDataArgs): FormApiMethodsRequestData => {
  return {
    ...(tokenRequestData ?? ({} as FormApiMethodsRequestData)),
    formType: tokenRequestData?.formType ?? formType,
    mode,
    sessionId,
    // Keep the edited row's id in sync with the paginated row; fall back to the token value
    id: currentRowId ?? tokenRequestData?.id,
    form,
  };
};
